const state = {
    statusList: ['全部', '未到访', '已到访', '已分配','已过期','人工分配','已失效', '已签约-租','已签约-售','复核可结佣', '已结佣'],
    userInfo: {}
}

const mutations = {
    SET_USERINFO: ( state, data) => {
        state.userInfo = data
    }
}

const actions = {
    setUserInfo( { commit }, data) {
        commit('SET_USERINFO', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
